import React, {useState, useEffect} from "react";
import { 
    Button, Typography, Paper, TextareaAutosize, Box
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import commonService from "../../services/common-service";
import SnackAlert from "../../shared/SnackAlert";
import Spinner from "../../shared/Spinner";
import { useParams } from "react-router-dom";

export default function IntegraQUERY(props) {
    const {domain} = useParams();
    const [spinner, setSpinner] = React.useState(false);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    const [integraQueryObj, setIntegraQueryObj] = useState({});

    useEffect(() => {
        let integraObj = {};
        integraObj['group'] = props.integraGroupQuery
        integraObj['group_geometry'] = props.geometryIntegraQuery;
        setIntegraQueryObj({...integraObj, ...props.integraQueryObj});
      }, []);

    const handleIntegraChange=(e) => {
        setIntegraQueryObj({...integraQueryObj, [e.target.name]: e.target.value});
    }
    
    const insertToDB = async () =>{
        setSpinner(true);
        Object.keys(integraQueryObj).map(function(key, index) {
            integraQueryObj[key] = integraQueryObj[key].replace(/\n/g, '');
        });
        integraQueryObj['domain'] = domain;
        const res = await commonService.insert_to_integra(integraQueryObj);
        console.log(res)
        if(res.data == true){
            setMsg("Zone Added Successfully");
            setSeverity('success');
            // props.handleNext();
        }else{
            setMsg(res.data.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
        }
        setAlert(true);
        setSpinner(false);
    }
    return (
        <div className="row">
            <Paper elevation={0} sx={{whiteSpace: 'pre-wrap', mt: 3, p: 2}}>
                <div className="row">
                    <Typography variant="h5" className="font-bold">IntegraMobile</Typography>
                    <div className="col-md-12">
                        <Typography variant="body1" className="font-bold">Literals & Groups</Typography>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={2}
                            name="group"
                            style={{ width: "100%", marginTop: '13px !important', border: 0, background: '#f0f0f0', padding: '15px'}}
                            value={integraQueryObj['group']}
                            onChange={(e)=>handleIntegraChange(e)}
                            ref={props.textAreaRef}
                        />
                    </div>
                    <div className="col-md-12">
                        <Typography variant="body1" className="font-bold">Group Geometry</Typography>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={2}
                            name="group_geometry"
                            style={{ width: "100%", marginTop: '13px !important', border: 0, background: '#f0f0f0', padding: '15px'}}
                            value={integraQueryObj['group_geometry']}
                            onChange={(e)=>handleIntegraChange(e)}
                            ref={props.textAreaRef}
                        />
                    </div>
                    <div className="col-md-12">
                        <Typography variant="body1" className="font-bold">Tariff</Typography>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={2}
                            name="integra_tarif"
                            style={{ width: "100%", marginTop: '13px !important', border: 0, background: '#f0f0f0', padding: '15px'}}
                            value={integraQueryObj['integra_tarif']}
                            onChange={(e)=>handleIntegraChange(e)}
                            ref={props.textAreaRef}
                        />
                    </div>
                    <div className="col-md-12">
                        <Typography variant="body1" className="font-bold">Tariff In Groups</Typography>
                        <TextareaAutosize
                            aria-label="minimum height"
                            minRows={2}
                            name="integra_tarif_in_group"
                            style={{ width: "100%", marginTop: '13px !important', border: 0, background: '#f0f0f0', padding: '15px'}}
                            value={integraQueryObj['integra_tarif_in_group']}
                            onChange={(e)=>handleIntegraChange(e)}
                            ref={props.textAreaRef}
                        />
                    </div>
                </div>
            </Paper>
            <Box sx={{ display: 'flex', flexDirection: 'row', py: 2 }}>
                <Button
                    color="inherit"
                    onClick={()=>props.handleBack()}
                    sx={{ mr: 1 }}
                    >
                    Back
                </Button>
                <Box sx={{ flex: '1 1 auto' }} />
                {/* <Button type="button" className="me-2" onClick={()=>{props.handleNext();}}>
                    Next
                </Button> */}
                <Button type="button" className="btn btn-blue px-3 fit-content" onClick={()=>{insertToDB()}}>
                    Insert to IntegraMobile
                </Button>
            </Box>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}
